export default () => ({
  open: false,
  _scrollPosition: 0,

  init() {
    window.addEventListener("open-login-modal", () => {
      this._open();
    });

    if (this.urlHashes && this.urlHashes.includes("login")) {
      this._open();
      if (window.history.pushState) {
        window.history.pushState("", "/", window.location.pathname);
      } else {
        window.location.hash = "";
      }
    }
  },

  get urlHashes() {
    if (!window.location.hash) return false;

    const hashes = [];
    window.location.hash
      .replace("#", "")
      .split("&")
      .forEach((hash) => {
        hashes.push(hash);
      });
    return hashes;
  },

  _open() {
    this.open = true;
    this._scrollPosition = window.pageYOffset;
    document.body.classList.add("login-modal--open");
    document.body.style.top = `-${this._scrollPosition}px`;
  },

  _close() {
    this.open = false;
    document.body.classList.remove("login-modal--open");
    document.body.style.top = null;
    window.scrollTo({
      top: this._scrollPosition,
      behavior: "instant",
    });
  },

  link: {
    ["@click.prevent"]() {
      this._open();
    },
  },

  close: {
    ["@click.prevent"]() {
      this._close();
    },
  },

  modal: {
    ["x-show"]() {
      return this.open;
    },
    ["@click.away"]() {
      this._close();
    },
    ["x-on:keydown.escape.window"]() {
      this._close();
    },
  },
});
